<template>
  <div
    class="modal fade"
    tabindex="-1"
    id="add-location-modal"
    ref="newTargetModalRef"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered mw-950px">
      <div class="modal-content rounded">
        <BlockUI :loading="block" />
        <div class="modal-header">
          <h5 class="modal-title">{{ translate(title) }}</h5>

          <!--begin::Close-->
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
            @click="closeModal"
            aria-label="Close"
          >
            <i class="bi bi-x-lg"></i>
          </div>
          <!--end::Close-->
        </div>

        <div class="modal-body rounded p-0">
          <Form
            v-slot="{ errors }"
            ref="refForm"
            id="example"
            class="form p-10 rounded-bottom"
            novalidate="novalidate"
            @submit="onSubmit"
            :validation-schema="locationValidator"
            style="padding-bottom: 1.5rem !important; background: #fbfbfb"
          >
            <div class="row mb-4">
              <label class="col-lg-4 col-form-label required fw-bold fs-6">{{
                translate("Customers")
              }}</label>
              <div class="col-lg-8 fv-row d-v-container">
                <div
                  class="fv-plugins-message-container d-v-content"
                  style="z-index: 1"
                >
                  <div class="fv-help-block ms-2 v-element">
                    <ErrorMessage name="customersId" />
                  </div>
                </div>

                <select
                  class="form-select form-select-lg fw-bold fs-6 text-dark"
                  v-if="
                    props.customerId !== 0 && props.customerId !== undefined
                  "
                  v-model="location.customerId"
                >
                  <option class="text-dark" :value="props.customerId" selected>
                    {{ props.customer.Name }}
                  </option>
                </select>

                <Field v-else name="customersId" v-model="location.customerId">
                  <Dropdown
                    :filter="!platform"
                    :emptyFilterMessage="translate('No_Records')"
                    v-model="location.customerId"
                    :options="customerList"
                    optionLabel="Value"
                    optionValue="Id"
                    :placeholder="
                      translate('location_modal_customer_placeholder')
                    "
                    style="padding: 5px !important"
                    :style="`${
                      errors['customersId'] !== undefined
                        ? 'border-color: #FE554C !important;'
                        : ''
                    }`"
                    appendTo="self"
                  >
                    <template v-slot:indicator>
                      <div
                        class="p-dropdown-trigger"
                        role="button"
                        aria-haspopup="listbox"
                        aria-expanded="false"
                      >
                        <span
                          class="p-dropdown-trigger-icon pi pi-chevron-down"
                        ></span>
                      </div>

                      <i
                        v-if="location.customerId === 0 ? false : true"
                        class="p-dropdown-clear-icon pi pi-times"
                        @click="location.customerId = 0"
                      ></i>
                    </template>
                  </Dropdown>
                </Field>
              </div>
            </div>
            <div class="row mb-4">
              <label class="col-lg-4 col-form-label required fw-bold fs-6">{{
                translate("location_modal_name")
              }}</label>
              <div class="col-lg-8 fv-row d-v-container">
                <div class="fv-plugins-message-container d-v-content">
                  <div class="fv-help-block ms-2 v-element">
                    <ErrorMessage name="locationName" />
                  </div>
                </div>
                <Field
                  type="text"
                  name="locationName"
                  :class="
                    errors['locationName'] !== undefined ? 'v-invalid' : ''
                  "
                  class="form-control form-control-lg fs-6"
                  :placeholder="translate('location_modal_name')"
                  v-model.trim="location.name"
                />
              </div>
            </div>
            <div class="row mb-4">
              <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                translate("location_modal_code")
              }}</label>
              <div class="col-lg-8 fv-row d-v-container">
                <input
                  type="text"
                  name="code"
                  class="form-control form-control-lg fs-6"
                  :placeholder="translate('location_modal_code')"
                  v-model.trim="location.code"
                />
              </div>
            </div>
            <div class="row mb-4">
              <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                translate("PhoneNumber")
              }}</label>
              <div class="col-lg-8 fv-row d-v-container">
                <input
                  type="text"
                  name="phoneNumber"
                  class="form-control form-control-lg fs-6"
                  :placeholder="translate('PhoneNumber')"
                  v-model.trim="location.phoneNumber"
                />
              </div>
            </div>
            <div class="row mb-4">
              <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                translate("Address")
              }}</label>
              <div class="col-lg-8">
                <!--begin::Row-->
                <div class="row">
                  <!--begin::Col-->
                  <div class="col-lg-4 fv-row">
                    <Dropdown
                      class="mb-3"
                      :filter="!platform"
                      :emptyFilterMessage="translate('No_Records')"
                      v-model="location.countryId"
                      :options="CountryList"
                      optionLabel="Value"
                      optionValue="Id"
                      :placeholder="translate('CountrySelect')"
                      style="padding: 5px !important"
                      @change="getCity"
                      appendTo="self"
                    >
                      <template v-slot:indicator>
                        <div
                          class="p-dropdown-trigger"
                          role="button"
                          aria-haspopup="listbox"
                          aria-expanded="false"
                        >
                          <span
                            class="p-dropdown-trigger-icon pi pi-chevron-down"
                          ></span>
                        </div>

                        <i
                          v-if="location.countryId === 0 ? false : true"
                          class="p-dropdown-clear-icon pi pi-times"
                          @click="(location.countryId = 0), getCity()"
                        ></i>
                      </template>
                    </Dropdown>
                  </div>
                  <div class="col-lg-4 fv-row">
                    <Dropdown
                      class="mb-3"
                      :filter="!platform"
                      :emptyFilterMessage="translate('No_Records')"
                      v-model="location.cityId"
                      :options="CityList"
                      optionLabel="Value"
                      optionValue="Id"
                      :placeholder="translate('CitySelect')"
                      style="padding: 5px !important"
                      @change="getDistrict"
                      appendTo="self"
                    >
                      <template v-slot:indicator>
                        <div
                          class="p-dropdown-trigger"
                          role="button"
                          aria-haspopup="listbox"
                          aria-expanded="false"
                        >
                          <span
                            class="p-dropdown-trigger-icon pi pi-chevron-down"
                          ></span>
                        </div>

                        <i
                          v-if="location.cityId === 0 ? false : true"
                          class="p-dropdown-clear-icon pi pi-times"
                          @click="(location.cityId = 0), getDistrict()"
                        ></i>
                      </template>
                    </Dropdown>
                  </div>
                  <div class="col-lg-4 fv-row">
                    <Dropdown
                      class="mb-3"
                      :filter="!platform"
                      :emptyFilterMessage="translate('No_Records')"
                      v-model="location.districtId"
                      :options="DistrictList"
                      optionLabel="Value"
                      optionValue="Id"
                      :placeholder="translate('DistrictSelect')"
                      style="padding: 5px !important"
                      appendTo="self"
                    >
                      <template v-slot:indicator>
                        <div
                          class="p-dropdown-trigger"
                          role="button"
                          aria-haspopup="listbox"
                          aria-expanded="false"
                        >
                          <span
                            class="p-dropdown-trigger-icon pi pi-chevron-down"
                          ></span>
                        </div>

                        <i
                          v-if="location.districtId === 0 ? false : true"
                          class="p-dropdown-clear-icon pi pi-times"
                          @click="location.districtId = 0"
                        ></i>
                      </template>
                    </Dropdown>
                  </div>

                  <!--end::Col-->
                </div>
                <!--end::Row-->
              </div>
            </div>

            <div class="row mb-4 justify-content-end">
              <div class="col-lg-8 fv-row">
                <input
                  type="text"
                  name="adress-detay"
                  class="form-control form-control-lg fs-6"
                  :placeholder="translate('AddressDetail')"
                  v-model.trim="location.streetAddress"
                />
              </div>
            </div>

            <div class="row mb-4">
              <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                translate("ActivitiyTypeAdd_3")
              }}</label>
              <div class="col-lg-8 fv-row">
                <Dropdown
                  class="mb-3"
                  :filter="!platform"
                  :emptyFilterMessage="translate('No_Records')"
                  v-model="location.operationTypeId"
                  :options="operationTypeList"
                  optionLabel="Value"
                  optionValue="Id"
                  :placeholder="
                    translate('location_modal_select_oparation_type')
                  "
                  style="padding: 5px !important"
                  appendTo="self"
                >
                  <template v-slot:indicator>
                    <div
                      class="p-dropdown-trigger"
                      role="button"
                      aria-haspopup="listbox"
                      aria-expanded="false"
                    >
                      <span
                        class="p-dropdown-trigger-icon pi pi-chevron-down"
                      ></span>
                    </div>

                    <i
                      v-if="location.operationTypeId === 0 ? false : true"
                      class="p-dropdown-clear-icon pi pi-times"
                      @click="location.operationTypeId = 0"
                    ></i>
                  </template>
                </Dropdown>
              </div>
            </div>

            <div class="row mb-4">
              <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                translate("location_modal_label_select_status")
              }}</label>
              <div class="col-lg-8 fv-row">
                <Dropdown
                  class="mb-3"
                  :filter="!platform"
                  :emptyFilterMessage="translate('No_Records')"
                  v-model="location.locationTypeId"
                  :options="locationTypeList"
                  optionLabel="Value"
                  optionValue="Id"
                  :placeholder="translate('location_modal_select_statu')"
                  style="padding: 5px !important"
                  appendTo="self"
                >
                  <template v-slot:indicator>
                    <div
                      class="p-dropdown-trigger"
                      role="button"
                      aria-haspopup="listbox"
                      aria-expanded="false"
                    >
                      <span
                        class="p-dropdown-trigger-icon pi pi-chevron-down"
                      ></span>
                    </div>

                    <i
                      v-if="location.locationTypeId === 0 ? false : true"
                      class="p-dropdown-clear-icon pi pi-times"
                      @click="location.locationTypeId = 0"
                    ></i>
                  </template>
                </Dropdown>
              </div>
            </div>

            <div class="row mb-4 justify-content-end">
              <div class="col-lg-8 fv-row">
                <div class="form-check form-check-custom form-check-solid">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="check-remember"
                    v-model="location.published"
                  />
                  <div class="d-flex flex-column position-relative w-100">
                    <label
                      class="form-check-label col-form-label fw-bold p-0 mt-2"
                      for="check-remember"
                      style="margin-bottom: 15px"
                    >
                      {{ translate("location_modal_check_label") }}
                    </label>
                    <label
                      class="
                        form-check-label
                        col-form-label
                        fw-bold
                        fs-7
                        p-0
                        text-gray-500
                      "
                      for="check-remember"
                      style="position: absolute; margin-top: 20px"
                    >
                      {{ translate("location_modal_check_label_description") }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="d-flex justify-content-end p-0"
              style="padding-top: 1.5rem !important"
            >
              <button
                @click="closeModal"
                type="reset"
                class="btn btn-white btn-active-light me-2 border btn-sm fs-6"
              >
                {{ translate("Cancel") }}
              </button>

              <button
                v-if="buttonShow"
                type="submit"
                id="kt_add_customer_submit"
                class="btn btn-primary border btn-sm fs-6"
                :disabled="loading"
              >
                <div
                  v-if="loading"
                  class="spinner-border spinner-border-sm mx-1"
                ></div>
                <span> {{ translate("Add") }} </span>
              </button>
              <a
                v-else
                @click="updateItem"
                :class="`btn btn-primary border btn-sm fs-6 ${
                  Object.keys(errors).length > 0 || loading ? 'disabled' : ''
                }`"
              >
                <div
                  v-if="loading"
                  class="spinner-border spinner-border-sm mx-1"
                ></div>
                <span class="indicator-label">
                  {{ translate("Save") }}
                </span>
              </a>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { hideModal } from "@/core/helpers/dom";
import {
  ref,
  reactive,
  computed,
  defineProps,
  defineEmits,
  watch,
  onMounted,
} from "vue";
import * as Yup from "yup";
import { useI18n } from "vue-i18n";
import store from "@/store";

const props = defineProps({
  locationId: Number,
  customer: Object,
  customerId: Number,
});

const emit = defineEmits(["closeModal"]);

const block = ref(false);
watch(props, () => {
  if (props.locationId !== 0) {
    block.value = true;
    buttonShow.value = false;
    store
      .dispatch("LocationModule/GET_LOCATİON", props.locationId)
      .then((response) => {
        title.value = response.Name;
        location.name = response.Name;
        location.code = response.Code;
        location.countryId = response.CountryId;
        if (location.countryId !== 0 || location.countryId !== null) {
          store.dispatch("LanguageModule/GET_CITYS", location.countryId);
        }
        location.cityId = response.CityId;
        if (location.cityId !== 0 || location.cityId !== null) {
          store.dispatch("LanguageModule/GET_DISTRICT", location.cityId);
        }

        location.districtId = response.DistrictId;
        location.streetAddress = response.StreetAddress;
        location.phoneNumber = response.PhoneNumber;
        location.customerId = response.CustomerId;
        location.operationTypeId = response.OperationTypeId;
        location.published = response.Published;
        location.locationTypeId = response.LocationTypeId;

        location.Id = response.Id;
        setTimeout(() => {
          block.value = false;
        }, 500);
      });
  } else {
    buttonShow.value = true;
  }
});

const platform = store.state.platform;

const location = reactive({
  name: null,
  code: null,
  countryId: 0,
  cityId: 0,
  districtId: 0,
  streetAddress: null,
  phoneNumber: null,
  customerId: 0,
  statusId: 0,
  operationTypeId: 0,
  locationTypeId: 0,
  published: true,
  Id: 0,
});

// Multi Language
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

// Validation Tanımlaması
const locationValidator = Yup.object().shape({
  locationName: Yup.string()
    .nullable()
    .required(translate("location_modal_validation_name")),
  customersId: Yup.number()
    .min(1)
    .positive(translate("location_modal_validation_customer")),
});

// Modal ve Form Değişkenleri
const newTargetModalRef = ref(null);
const refForm = ref(null);
const title = ref(translate("NewLocation"));
const buttonShow = ref(true);
const loading = ref(false);
// Değişkenler
const customerList = ref([]);
const operationTypeList = ref([]);
const locationTypeList = ref([]);

// Submit İşlemleri
const onSubmit = (values, { resetForm }) => {
  loading.value = true;
  if (props.customerId != undefined) {
    store.dispatch("LocationModule/ADD_LOCATION", location).then((response) => {
      if (response) {
        store.dispatch("LocationModule/GET_ALL_LOCATION", {
          page: 1,
          pageSize: 10,
          customerId: props.customerId,
        });
        loading.value = false;
      }
    });
  } else {
    store.dispatch("LocationModule/ADD_LOCATION", location).then((response) => {
      if (response) {
        store.dispatch("LocationModule/GET_ALL_LOCATION", {
          page: 1,
          pageSize: 10,
        });
        loading.value = false;
      }
    });
  }
  closeModal();
};

// Update Item
const updateItem = () => {
  loading.value = true;
  store
    .dispatch("LocationModule/UPDATE_LOCATION", location)
    .then((response) => {
      loading.value = false;
      if (response) {
        if (props.customerId !== undefined) {
          store.dispatch("LocationModule/GET_ALL_LOCATION", {
            page: 1,
            pageSize: 10,
            customerId: props.customerId,
          });
        } else {
          store.dispatch("LocationModule/GET_ALL_LOCATION", {
            page: 1,
            pageSize: 10,
          });
        }
      }
    });
  closeModal();
};

// Modal Close
const closeModal = () => {
  hideModal(newTargetModalRef.value);
};

// Get Customers
const getCustomers = () => {
  store.dispatch("CustomerModule/GET_COMMONN_CUSTOMERS").then((response) => {
    customerList.value = response;
  });
};

//Get Operation Type
const getOperationType = () => {
  store.dispatch("ActivityTypeModule/GET_COMMON_ACTIVITY").then((response) => {
    operationTypeList.value = response;
  });
};

const getLocationType = () => {
  store.dispatch("LocationModule/GET_COMMON_LOCATION_TYPE").then((response) => {
    locationTypeList.value = response;
  });
};

//Adres İşlemleri
store.dispatch("LanguageModule/GET_ALL_COUNTRY");
const CountryList = computed(
  () => store.getters["LanguageModule/_getCountryList"]
);
const CityList = computed(() => store.getters["LanguageModule/_getCityList"]);
const DistrictList = computed(
  () => store.getters["LanguageModule/_getDistrictList"]
);
const getCity = () => {
  location.cityId = 0;
  location.districtId = 0;
  store.dispatch("LanguageModule/GET_CITYS", location.countryId);
};
const getDistrict = () => {
  location.districtId = 0;
  store.dispatch("LanguageModule/GET_DISTRICT", location.cityId);
};

const formClear = () => {
  setTimeout(() => {
    location.name = null;
    location.code = null;
    location.countryId = 0;
    location.cityId = 0;
    location.districtId = 0;
    location.streetAddress = null;
    location.phoneNumber = null;
    location.customerId = props.customerId === undefined ? 0 : props.customerId;
    location.statusId = 0;
    location.operationTypeId = 0;
    location.published = true;
    location.locationTypeId = 0;
    location.Id = 0;

    title.value = translate("NewLocation");
    refForm.value.resetForm();
    emit("closeModal");
  }, 300);
};

onMounted(() => {
  if (props.customerId !== 0 && props.customerId !== undefined) {
    location.customerId = parseInt(props.customerId);
  }
  document
    .getElementById("add-location-modal")
    .addEventListener("hide.bs.modal", function () {
      formClear();
    });
});
getCustomers();
getOperationType();
getLocationType();
</script>
